import { presets, defaultBgColor } from "config/images";
import ImageAdapter from "theme/components/atoms/Image/ImageAdapter";

class FrontCommerceImageProxy extends ImageAdapter {
  name = "FrontCommerceImageProxy";

  /**
   * @inheritdoc
   * @type {ImageAdapter["supportSrc"]}
   */
  supportSrc(src) {
    return src.startsWith("/");
  }

  /**
   * @inheritdoc
   * @type {ImageAdapter["makeImageSrc"]}
   */
  makeImageSrc(
    src,
    format,
    size,
    bg,
    extension,
    cover,
    baseUrl = "",
    focalPoint = undefined
  ) {
    const config = presets[format];

    let query = "";
    if (config) {
      const colors = config.bgColors || [];
      query += `format=${format}&width=${config.width}&height=${config.height}`;
      if (!size) {
        const sizes = config.sizes || [0.5, 1, 2, 4];
        size = sizes[0];
      }
      query += `&size=${size}`;
      if (bg && colors.concat(defaultBgColor).indexOf(bg) > -1) {
        query += `&bg=${bg}`;
      }
      if (cover) {
        query += `&cover=true`;
      }
      if (extension) {
        query += `&extension=${extension}`;
      } else {
        query += `&extension=${this.getDefaultExtension()}`;
      }
      if (focalPoint) {
        query += `&focalPoint=${focalPoint.x}x${focalPoint.y}`;
      }
    }

    const joinCharacter = src.indexOf("?") > -1 ? "&" : "?";

    return baseUrl + src + joinCharacter + query;
  }
}

export default new FrontCommerceImageProxy();
